import { render, staticRenderFns } from "./BiometryAuthHeader.vue?vue&type=template&id=7e9009b4&"
import script from "./BiometryAuthHeader.vue?vue&type=script&lang=js&"
export * from "./BiometryAuthHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports